import { Component, EmbeddedViewRef, TemplateRef, ViewChild } from '@angular/core';

import { ContentDirective } from '../directives';
import { ParsedTextSegmentType } from '../types/parse-text-types';
import { parseText } from '../utils/parse-text';

@Component({
  template: '',
})
export abstract class GenericTableCellComponent {
  @ViewChild(ContentDirective, { static: true })
  protected content: ContentDirective;

  @ViewChild('text', { read: TemplateRef, static: true })
  protected textTemplate: TemplateRef<unknown>;

  @ViewChild('icon', { read: TemplateRef, static: true })
  protected iconTemplate: TemplateRef<unknown>;

  @ViewChild('br', { read: TemplateRef, static: true })
  protected brTemplate: TemplateRef<unknown>;

  private readonly embeddedViews: EmbeddedViewRef<unknown>[] = [];

  protected abstract getValue(): string | number | null;

  protected build(): void {
    this.clearEmbeddedViews();

    const value = this.getValue();

    if (value === null) {
      return;
    }

    if (typeof value === 'number') {
      const embed = this.content.viewContainerRef.createEmbeddedView(this.textTemplate, { text: `${value}` });
      this.embeddedViews.push(embed);
      return;
    }

    for (const segment of parseText(value)) {
      let embed: EmbeddedViewRef<unknown>;

      switch (segment.type) {
        case ParsedTextSegmentType.ICON:
          embed = this.content.viewContainerRef.createEmbeddedView(this.iconTemplate, { icon: segment.value });
          break;

        case ParsedTextSegmentType.TEXT:
          embed = this.content.viewContainerRef.createEmbeddedView(this.textTemplate, { text: segment.value });
          break;

        case ParsedTextSegmentType.LINEBREAK:
          embed = this.content.viewContainerRef.createEmbeddedView(this.brTemplate);
      }

      this.embeddedViews.push(embed);
    }
  }

  private clearEmbeddedViews(): void {
    for (const embed of this.embeddedViews) {
      embed.destroy();
    }
    this.embeddedViews.length = 0;
  }
}
